import React from "react";
import { MainNavbar } from "./core/MainNavbar";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import { routes } from "./core/routes";
import { EventsView } from "./domain/EventsView";
import { ServicesPanel } from "./domain/ServicesPanel";
import { FacilityPanel } from "./domain/FacilityPanel";
import { AppointmentsPanel } from "./domain/AppointmentsPanel";
import { SchedulesPanel } from "./domain/SchedulesPanel";
import { DoctorsPanel } from "./domain/DoctorsPanel";
import { AppWithDefaultAuth, DialogRenderer } from "@optimed/react";
import { ToastRenderer } from "@optimed/react";

export function App() {
  return (
    <AppWithDefaultAuth appName="Optimed Docplanner">
      <HashRouter>
        <DialogRenderer />
        <ToastRenderer />
        <div className="App">
          <MainNavbar />
          <div className="container">
            <FacilityPanel />
            <Routes>
              <Route path={routes.doctors} element={<DoctorsPanel />} />
              <Route path={routes.services} element={<ServicesPanel />} />
              <Route path={routes.schedules} element={<SchedulesPanel />} />
              <Route path={routes.bookings} element={<AppointmentsPanel />} />
              <Route path={routes.events} element={<EventsView />} />
              <Route path="*" element={<Navigate to={routes.doctors} />} />
            </Routes>
          </div>
        </div>
      </HashRouter>
    </AppWithDefaultAuth>
  );
}
